/**
 * グローバルキーボードショートカットハンドラー
 * フォームコントロール以外の要素でのキーボードショートカットを処理
 */

import logger from './logger';

/**
 * フォームコントロールかどうかを判定
 */
function isFormControl(element: Element | null): boolean {
  return element !== null && (
    element.tagName === 'INPUT' ||
    element.tagName === 'TEXTAREA' ||
    element.getAttribute('contenteditable') === 'true'
  );
}

/**
 * グローバルキーボードイベントハンドラー
 */
export function handleGlobalKeyDown(event: KeyboardEvent) {
  const target = event.target as Element;
  const key = event.key.toLowerCase();
  const isCmd = event.metaKey || event.ctrlKey;
  
  // フォームコントロールの場合は、ブラウザのデフォルト動作に任せる
  if (isFormControl(target)) {
    return;
  }
  
  // テキストが選択されている場合のコピー
  if (isCmd && key === 'c') {
    const selection = window.getSelection();
    if (selection && selection.toString()) {
      event.preventDefault();
      navigator.clipboard.writeText(selection.toString())
        .then(() => {
        })
        .catch((error) => {
          logger.error('[GlobalKeyboardShortcuts] Failed to copy:', error);
        });
    }
  } else if (isCmd && key === 'a') {
    // 全選択（特定の要素内でのみ動作するように制限可能）
    const selection = window.getSelection();
    if (selection) {
      // 現在のフォーカス要素内のテキストを全選択
      const focusNode = selection.focusNode;
      if (focusNode) {
        event.preventDefault();
        const range = document.createRange();
        
        // テキストノードの場合は親要素を使用
        const container = focusNode.nodeType === Node.TEXT_NODE 
          ? focusNode.parentElement 
          : focusNode as Element;
          
        if (container) {
          range.selectNodeContents(container);
          selection.removeAllRanges();
          selection.addRange(range);
        }
      }
    }
  }
}

logger.info('[GlobalKeyboardShortcuts] Global keyboard shortcuts handler initialized');